import type { UserDTO, AuthResponseDTO, Enable2FAResponseDTO } from '@shared/api/contracts/auth';
import type { User, AuthResponse, TwoFactorSetup } from '../model/types';

const readPermissions = (value: UserDTO['permissions']): string[] | undefined => {
  if (!Array.isArray(value)) return undefined;
  return value.filter((item): item is string => typeof item === 'string');
};

export function mapUserDtoToEntity(dto: UserDTO): User {
  const isAdmin = dto.role === 'ADMIN' || Boolean(dto.isAdmin);

  return {
    id: String(dto.id),
    email: dto.email,
    fullName: dto.fullName,
    country: dto.country,
    role: dto.role,
    isAdmin,
    permissions: readPermissions(dto.permissions),
    twoFactorEnabled: Boolean(dto.isTwoFaEnabled ?? dto.twoFactorEnabled),
    referralCode: dto.referralCode,
    withdrawalsLockedUntil: dto.withdrawalsLockedUntil ?? null,
    apiToken: dto.apiToken ?? null,
  };
}

export function mapAuthResponseDtoToEntity(dto: AuthResponseDTO): AuthResponse {
  return {
    tokens: {
      accessToken: dto.token,
    },
    action: dto.action,
    user: dto.user ? mapUserDtoToEntity(dto.user) : undefined,
    methods: dto.methods,
    sentTo: dto.sentTo,
    backupCodes: dto.backupCodes,
    resendAfterSec: dto.resendAfterSec,
  };
}

export function map2FASetupDtoToEntity(dto: Enable2FAResponseDTO): TwoFactorSetup {
  return {
    qrCode: dto.qr,
    otpauthUrl: dto.otpauth_url,
  };
}
